import {
  FilterMode,
  ShowcaseWorkflowStateCreateMutationVariables,
  ShowcaseWorkflowState_OrderBy,
  ShowcaseWorkflowState,
  SortOrder,
  ShowcaseWorkflowState_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const showcaseWorkflowStateService = {
  createOne: buildCreateOne(
    (
        showcaseWorkflowStateCreateVariables: ShowcaseWorkflowStateCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.showcaseWorkflowStateCreate(
          showcaseWorkflowStateCreateVariables
        );
        return result.showcaseWorkflowStateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.showcaseWorkflowStateOne({ id });
    return result.showcaseWorkflowStateOne as ShowcaseWorkflowState;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: ShowcaseWorkflowState_OrderBy[] | null = null,
    filter: ShowcaseWorkflowState_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ShowcaseWorkflowState_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.showcaseWorkflowStateListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.showcaseWorkflowStateListWithOffset
    ) as ShowcaseWorkflowState[];
    return { list, orderBy };
  },
};
